export default "__VITE_ASSET__BpSKc1ct__"